import script from "./ContactBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactBlock.vue?vue&type=script&setup=true&lang=js"

import "./ContactBlock.vue?vue&type=style&index=0&id=f6742778&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f6742778"]])

export default __exports__